import moment    from 'moment'
import Immutable from 'immutable'

import { formatDate, dateFormat } from 'alto-utils/lib/utils'

import DailyMenu from './daily_menu'

export default class CanteenMenu
  constructor: (@canteen, @_dailyMenus, @_menu) ->

  dates: ->
    @_menu.dates

  dailyMenus: ->
    @_dailyMenus?.map(@_dailyMenuFor.bind(@)).valueSeq() or new Immutable.Seq

  dailyMenuFor: (date) ->
    groupMenus = @_dailyMenus?.get(date.format(dateFormat)) or null

    new DailyMenu(@canteen, date, groupMenus, @_menu)

  _dailyMenuFor: (groupMenus, formattedDate) ->
    new DailyMenu(@canteen, moment(formattedDate, dateFormat), groupMenus, @_menu)
